import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { StatisticCardProps } from '@/types';

function StatisticCard({ isLoading, children, title, bgColor, tooltip }: StatisticCardProps) {
  if (isLoading) {
    return (
      <div className="flex flex-col gap-3 rounded-xl border border-neutral-200/80 bg-white p-5 shadow-sm">
        <Skeleton className="h-4 w-24 rounded" />
        <Skeleton className="h-8 w-20 rounded" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'relative flex flex-col gap-2 rounded-xl border border-neutral-200/80 bg-white p-5 shadow-sm overflow-hidden',
      )}
    >
      {/* Colored accent bar */}
      <div
        className="absolute left-0 top-0 bottom-0 w-1"
        style={{ backgroundColor: bgColor || '#096846' }}
      />
      <div className="flex items-center gap-1.5">
        <h4 className="text-sm font-medium text-neutral-500">{title}</h4>
        {tooltip && (
          <TooltipProvider>
            <Tooltip delayDuration={0}>
              <TooltipTrigger asChild className="cursor-help">
                <Info
                  size={14}
                  className="text-neutral-400 hover:text-neutral-600 transition-colors"
                />
              </TooltipTrigger>
              <TooltipContent className="max-w-[220px]">
                <p className="text-xs">{tooltip}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      <span className="text-2xl font-semibold text-neutral-900">{children}</span>
    </div>
  );
}

export default StatisticCard;
